<script>
export default {
    //APIURL : 'http://localhost:8080/api/',
    //APIURL : 'http://st-pp.asahi-y.ed.jp/api/',
    APIURL : 'https://portal.asahi-y.ed.jp/api/',
}
</script>